import { LPermission } from '../mdl/l-permission';
import { the_user } from './login';

function havePermission(permission: LPermission) {
    return the_user?.email == 'gratal@gmail.com' || !!the_user?.permissions[permission];
}

export function amSuperuser() {
    return the_user?.email == 'gratal@gmail.com';
}

export function canManagePermissions() {
    return havePermission('admin.permissions.manage');
}

export function canManagePages() {
    return havePermission('admin.pages.manage');
}

export function canManageRoutes() {
    return havePermission('admin.routes.manage');
}

export function canManageLockedPages() {
    return amSuperuser();
}

export function canManageLockedRoutes() {
    return amSuperuser();
}

export function canViewTranslations() {
    return havePermission('admin.translations.view') || havePermission('admin.translations.manage');
}

export function canManageTranslations() {
    return havePermission('admin.translations.manage');
}

export function canViewPermissions() {
    return (havePermission('admin.permissions.manage') || havePermission('admin.permissions.view'));
}

export function canManageAccounting() {
    return havePermission('admin.accounting.manage');
}

export function canManageEconomy() {
    return havePermission('admin.economy.manage');
}

export function canManageUsers() {
    return havePermission('admin.users.manage');
}

export function canViewGiftCards() {
    return havePermission('admin.giftcards.manage') || havePermission('admin.giftcards.view');
}

export function canManageVenues() {
    return havePermission('admin.venues.manage');
}

export function canManageProducers() {
    return havePermission('admin.producers.manage');
}

export function canManageBookings() {
    return havePermission('admin.bookings.manage');
}

export function canManageEvents() {
    return havePermission('admin.events.manage');
}

export function canManagePDF() {
    return havePermission('admin.pdf.manage');
}

export function canManageVideo() {
    return havePermission('admin.video.manage');
}

export function canManageEmail() {
    return havePermission('admin.email.manage');
}

export function canViewStatistics() {
    return havePermission('admin.statistics.view');
}

export function canManageSystem() {
    return havePermission('admin.system.manage');
}
